import React, {Component} from 'react';
import Slideshow from "../Common/Slideshow";
import LogoPic from "../../assets/images/logo.png";
import LogoGohar from "../../assets/images/goharzaminLogo.png";
import API from '../../services/API';
import {Link} from "react-router-dom";
import Toast from '../Common/Toast';
import { toast } from 'react-toastify';

class Login extends Component {
    state = {
        mobile : "",
        buttonStatus: "disabled",
        buttonText : "دریافت کد تایید",
        loading: "d-none",
        message: ""
    }
    onInputChange = (event) => {
        const mobile = event.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
            this.setState({buttonStatus: ""})
        } else {
            this.setState({buttonStatus: "disabled"})
        }
        this.setState({mobile});
    }
    onButtonClick =  () => {
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const mobile = this.state.mobile;
         API.sendOTP(mobile)
             .then((response) => {
                 toast.success(response.user_message);
                 window.localStorage.setItem("mobile", this.state.mobile);
                 window.localStorage.setItem("new_user",response.results.new_user);
                 if (typeof response.results.otp !== 'undefined') {
                     window.localStorage.setItem("otp",response.results.otp);
                 }
                 setTimeout (() => {
                     this.props.history.push("/verify");
                 },1500)
                 })
             .catch((error) => {
                 const buttonText  = "دریافت کد تایید";
                 const  loading = "d-none";
                 const buttonStatus = "";
                 this.setState({buttonText,loading,buttonStatus });
                 toast.error(error.response.data.user_message);
             });
    }
    render() {
        return (
            <React.Fragment>
                <Toast  />
                <section className="container-fluid ">
                    <div className="row">
                        <div className="col-md-5 pt-2 ">
                            <div className="card border-1 rounded-more vh100">
                                <div className="col-12 pt-2">
                                    {
                                        window.localStorage.getItem("sysTitle").indexOf('زمین') < 0 ?
                                            <img src={LogoPic} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " /> :
                                            <img src={LogoGohar} alt={window.localStorage.getItem("sysTitle")} className="rounded-3 mx-auto d-block mt-5  " width='200' />
                                    }

                                </div>
                                <h3 className="col-12 text-center mt-5 mb-3 header-text">
                                   ورود به سامانه
                                    {window.localStorage.getItem("sysTitle")}
                                </h3>
                                <hr className="w-50 m-auto my-3 text-secondary"/>
                                <div className="mt-5 px-5">
                                    <input type="number" autoFocus value={this.state.mobile} onChange={this.onInputChange}
                                           className="form-control form-control-lg text-center rounded-more"
                                           aria-describedby="passwordHelpBlock" placeholder="شماره همراه"/>
                                    <small id="passwordHelpBlock"
                                           className="form-text text-muted super-small d-block mt-5  text-center">
                                        ثبت نام در سامانه به معنای پذیرفتن
                                        &nbsp;
                                        <Link to="/rules">قوانین و مقررات</Link>
                                        &nbsp;
                                        سامانه است.
                                    </small>
                                </div>
                                <div className="mt-3 px-5">
                                    <button onClick={this.onButtonClick} disabled={this.state.buttonStatus} type="submit"
                                            className="btn btn-primary w-100 py-2">
                                        {this.state.buttonText}
                                        <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                               aria-hidden="true"></span>
                                    </button>
                                </div>

                                <section className='row mt-3 '>
                                    <div className="col-6">
                                        <a referrerPolicy="origin" target="_blank" rel="noreferrer"
                                           href="https://trustseal.enamad.ir/?id=177863&amp;Code=1g7OmmZsAagKsawkDSvM"><img
                                            referrerPolicy="origin"
                                            src="https://Trustseal.eNamad.ir/logo.aspx?id=177863&amp;Code=1g7OmmZsAagKsawkDSvM"
                                            alt="اینماد"  id="1g7OmmZsAagKsawkDSvM"/></a>
                                    </div>
                                    <div className="col-6">
                                        <img referrerPolicy="origin" id='nbqejxlznbqefukznbqenbqe'

                                             onClick={() =>{window.open("https://logo.samandehi.ir/Verify.aspx?id=212622&p=uiwkrfthuiwkgvkauiwkuiwk", "Popup","toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")}}
                                             alt='logo-samandehi'
                                             src='https://logo.samandehi.ir/logo.aspx?id=212622&p=odrfnbpdodrfwlbqodrfodrf'/>
                                    </div>
                                </section>
                            </div>

                        </div>

                        <div className="col-md-7 ">
                           <Slideshow />
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
    componentDidMount() {

    }
}

export default Login;